<mat-table [dataSource]="datasource" style="height:100%;">
    <ng-container matColumnDef="entry">
      <mat-cell *matCellDef="let element; let index = index">
          <app-prescription-entry [entry]="element" (removed)="entryRemoved($event)"  style="width:100%;"></app-prescription-entry>
      </mat-cell>
    </ng-container>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>